export const countryNameToFlag = (name) => {
  if (!name) return "";
  const key = name.trim().toLowerCase();
  const map = {
    usa: "🇺🇸",
    "united states": "🇺🇸",
    uk: "🇬🇧",
    "united kingdom": "🇬🇧",
    england: "🇬🇧",
    india: "🇮🇳",
    "hong kong": "🇭🇰",
    "south africa": "🇿🇦",
    "saudi arabia": "🇸🇦",
    "saudi": "🇸🇦",
    "saudi arab": "🇸🇦",
    "united arab emirates": "🇦🇪",
    "uae": "🇦🇪",
    "emirates": "🇦🇪",
    ireland: "🇮🇪",
    chile: "🇨🇱",
    argentina: "🇦🇷",
    australia: "🇦🇺",
    brazil: "🇧🇷",
    "new zealand": "🇳🇿",
    denmark: "🇩🇰",
  };
  return map[key] || "";
};

export const getCountryFromFixture = (fixture) => {
  if (!fixture) return null;
  const tags = fixture["meta-tags"] || [];
  if (Array.isArray(tags)) {
    for (const tag of tags) {
      const tagType = tag?.type?.toString().toUpperCase();
      if (tagType.includes("COUNTRY")) {
        const value = tag?.name;
        if (value) return value;
      }
    }
  }
  return null;
};


